export class QuestionAnswer {
    constructor(
      public EligibilityGuid: string,
      public Question: string,
      public Answer: string
    ) {}
  }
